module.exports = __webpack_public_path__ + "2ad73b0f0ed354019f0af4be540c6d1c.MP3";